export default __webpack_public_path__ + "static/media/cronologia-primera-asamblea.e7c30581.jpg";